import { render } from "./MVoiceMessages.vue?vue&type=template&id=9c7d4166&scoped=true"
import script from "./MVoiceMessages.vue?vue&type=script&lang=js"
export * from "./MVoiceMessages.vue?vue&type=script&lang=js"

import "./MVoiceMessages.vue?vue&type=style&index=0&id=9c7d4166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7d4166"]])

export default __exports__